import React, { useState } from 'react';
import './WelcomePopup.css';

const EN = 'en';
const HI = 'hi';

const content = {
  [EN]: {
    title: 'You Deserve Better!',
    p1: <>
      <strong>Your privacy matters.</strong> We don't save any of your data —
      because we don't have a database yet. Simple as that. No worries.
    </>,
    p2: <>
      <strong>Everything, absolutely free.</strong> Premium templates,
      powerful editing, PDF/DOCX export — all the features that cost
      hundreds elsewhere are right here, completely free.
    </>,
    p3: <>
      If this helped you, <strong>share it with one person</strong> who
      needs it too. Let's build better resumes, together.
    </>,
    shareBtn: '📋 Copy Link & Share',
    shareBtnCopied: '✓ Link Copied!',
    footer: 'Built with ❤️ for everyone',
    toggle: 'हिंग्लिश में देखें',
    mobileWarning: '📱 Tip: For the best experience, please open this on a laptop/desktop!',
  },
  [HI]: {
    title: 'आप बेहतर के हकदार हैं!',
    p1: <>
      <strong>आपकी प्राइवेसी safe है।</strong> हम आपका कोई data save नहीं करते —
      क्योंकि हमारा कोई database नहीं है। इतना simple. No tension.
    </>,
    p2: <>
      <strong>सब कुछ bilkul free.</strong> Premium templates, powerful editing,
      PDF/DOCX export — जो features दूसरी जगह hundreds में मिलते हैं,
      वो सब यहाँ पर बिल्कुल free.
    </>,
    p3: <>
      अगर यह आपके काम आया, तो <strong>किसी एक friend को share करें</strong>
      जिसे इसकी ज़रूरत है। Let's build better resumes, together.
    </>,
    shareBtn: '📋 लिंक कॉपी करें और शेयर करें',
    shareBtnCopied: '✓ लिंक कॉपी हो गया!',
    footer: '❤️ से बनाया गया सबके लिए',
    toggle: 'View in English',
    mobileWarning: '📱 टिप: बेहतरीन अनुभव के लिए, कृपया इसे लैपटॉप/डेस्कटॉप पर खोलें!',
  },
};

const WelcomePopup = ({ onClose }) => {
  const [lang, setLang] = useState(EN);
  const [copied, setCopied] = useState(false);
  const t = content[lang];

  const toggleLang = () => setLang(prev => (prev === EN ? HI : EN));

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.origin).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="welcome-overlay">
      <div className="welcome-popup">
        <button className="welcome-close" onClick={onClose}>×</button>

        <div className="welcome-version">v2.0</div>

        <div className="welcome-icon">🚀</div>
        <h2 className="welcome-title">{t.title}</h2>

        <div className="welcome-content">
          <div className="welcome-mobile-warning">{t.mobileWarning}</div>
          <p>{t.p1}</p>
          <p>{t.p2}</p>
          <p>{t.p3}</p>
          <p className="welcome-feedback">
            💬 For feedback &amp; upgrades, comment here —<br />
            <a href="https://www.linkedin.com/posts/abhishek-maurya-707106158_resumebuilder-collegelife-jobsearch-activity-7282985440368873472-Dba0?utm_source=share&utm_medium=member_desktop&rcm=ACoAACW_OHcB17oGkEcPXYgbVqM4kaT8hBdwscg" target="_blank" rel="noopener noreferrer">
              linkedin.com/in/abhishek-maurya
            </a>
          </p>
        </div>

        <button className="welcome-share-btn" onClick={handleCopyLink}>
          {copied ? t.shareBtnCopied : t.shareBtn}
        </button>

        <button className="welcome-lang-toggle" onClick={toggleLang}>
          {t.toggle}
        </button>

        <p className="welcome-footer-text">{t.footer}</p>
      </div>
    </div>
  );
};

export default WelcomePopup;
